import { useEffect, useRef, useState } from "react";
import { intlFormat, makeDateString } from "../../helpers/helpers";
import {
  fetchUsers,
  fetchWaBlacklists,
  fetchWaLogs,
} from "../../helpers/fetchers";
import { useAppState } from "../../components/AppProvider/AppProvider";
import { User } from "../../model";
import { usePermission } from "../../components/Permission/Permission";
import { PERMISSIONS } from "../../helpers/permissions";

const WABlacklistPage = () => {
  const [ctx, dispatch] = useAppState() ?? [];
  const from = useRef(`${makeDateString(new Date())}T00:00`);
  const to = useRef(`${makeDateString(new Date())}T23:59`);
  const [, refresh] = useState(false);
  const blacklists = useRef([] as any[]);
  const users = useRef([] as User[]);
  const canManage = usePermission(PERMISSIONS.WA_BLACKLIST_MANAGE);

  const render = () => {
    refresh((n) => !n);
  };

  const fetchWaBlacklistsData = async () => {
    const d = await fetchWaBlacklists({ apiKey: ctx?.apiKey ?? "" });

    if (d) {
      blacklists.current = d;
      render();
    }
  };

  const fetchUsersData = async () => {
    const d = await fetchUsers(
      process.env.REACT_APP_BASE_URL ?? "",
      ctx?.apiKey ?? "",
      { showHidden: true }
    );

    if (d) {
      users.current = d;
      render();
    }
  };

  const handleInit = async () => {
    fetchWaBlacklistsData();
    fetchUsersData();
  };

  useEffect(() => {
    handleInit();
  }, []);

  const usersMapped: { [key: string]: User } = {};

  users.current.forEach((u) => {
    usersMapped[u.id ?? ""] = u;
  });

  const handleSave = async () => {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BASE_URL}/whatsappserviceblacklists-save-bulk`,
        {
          method: "post",
          headers: {
            authorization: ctx?.apiKey ?? "",
            "content-type": "application/json",
          },
          body: JSON.stringify(blacklists.current),
        }
      );

      window.location.reload();
    } catch (e) {}
  };

  return (
    <>
      <div className="m-3">
        <div>
          <strong>WA Blacklist</strong>
        </div>
        <div>
          <hr className="border border-dark" />
        </div>

        <div>
          <button
            className="btn btn-sm btn-primary"
            disabled={!canManage}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>

        <div>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => {
              blacklists.current = [...blacklists.current, {}];
              render();
            }}
          >
            Insert
          </button>
        </div>
        <div
          style={{ resize: "vertical", height: "75vh" }}
          className="border border-dark overflow-auto"
        >
          <table
            className="table table-sm"
            style={{ borderCollapse: "separate" }}
          >
            <tr>
              {["#", "Name"].map((h) => {
                return (
                  <>
                    <th
                      className="bg-dark text-light"
                      style={{ position: "sticky", top: 0 }}
                    >
                      {h}
                    </th>
                  </>
                );
              })}
            </tr>
            {blacklists?.current.map((b, i) => {
              return (
                <>
                  <tr>
                    <td className="border border-dark">{i + 1}</td>
                    <td className="border border-dark">
                      <input
                        className="form-control form-control-sm"
                        placeholder="Name..."
                        defaultValue={b?.name}
                        onBlur={(e) => {
                          b.name = e.target.value;
                          render();
                        }}
                      />
                    </td>
                  </tr>
                </>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
};
export default WABlacklistPage;
